<script setup>
import { MapPin } from "lucide-vue-next";

defineProps({
  location: { type: String, default: null },
});
</script>

<template>
  <div
    v-if="location"
    class="flex items-center gap-2 text-sm text-foreground/90"
  >
    <MapPin class="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
    <div class="truncate">{{ location }}</div>
  </div>
</template>
